import * as actionTypes from "../constants";
import * as requestEventService from "../services/requestEventService";

export function createRequestEvent(data, token, dispatch, placeHolderIndex) {
  dispatch({
    type: actionTypes.CREATE_REQUEST_EVENT_REQUEST,
    payload: placeHolderIndex,
  });
  return requestEventService
    .createRequestEvent(data, token)
    .then((res) => {
      dispatch({
        type: actionTypes.CREATE_REQUEST_EVENT_SUCCESS,
        payload: res.data.event,
      });
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.CREATE_REQUEST_EVENT_FAILURE,
      });
      throw err;
    });
}

export function updateRequestEvent(
  requestedEventId,
  token,
  dispatch,
  placeHolderIndex
) {
  dispatch({
    type: actionTypes.UPDATE_REQUEST_EVENT_REQUEST,
    payload: placeHolderIndex,
  });
  return requestEventService
    .updateRequestEvent(requestedEventId, token)
    .then((res) => {
      dispatch({
        type: actionTypes.UPDATE_REQUEST_EVENT_SUCCESS,
        payload: res.data.event,
      });
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.UPDATE_REQUEST_EVENT_FAILURE,
      });
      throw err;
    });
}

export function createRequestEventFromChat(
  data,
  token,
  dispatch,
  placeHolderIndex
) {
  dispatch({
    type: actionTypes.CREATE_REQUEST_EVENT_REQUEST,
    payload: placeHolderIndex,
  });
  return requestEventService
    .createRequestEventFromChat(data, token)
    .then((res) => {
      dispatch({
        type: "SET_REQUEST_EVENT_CHAT_MODAL",
        payload: res.data.event._id,
      });

      dispatch({
        type: actionTypes.CREATE_REQUEST_EVENT_SUCCESS,
        payload: res.data.event,
      });
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.CREATE_REQUEST_EVENT_FAILURE,
      });
      throw err;
    });
}

export function getAllRequestEvents(room, dispatch) {
  dispatch({
    type: actionTypes.GET_ALL_REQUEST_EVENT_REQUEST,
  });
  return requestEventService
    .getAllRequestEvents(room)
    .then((res) => {
      dispatch({
        type: actionTypes.GET_ALL_REQUEST_EVENT_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      throw err;
    });
}

export function createEventFromRequestEvent(
  data,
  token,
  dispatch,
  placeHolderIndex
) {
  dispatch({
    type: actionTypes.CREATE_EVENT_REQUEST,
  });
  dispatch({
    type: actionTypes.CREATE_EVENT_FROM_REQUEST_EVENT_REQUEST,
    payload: placeHolderIndex,
  });
  return requestEventService
    .createEventFromRequestEvent(data, token)
    .then((res) => {
      if (res.data?.event) {
        dispatch({
          type: actionTypes.CREATE_EVENT_SUCCESS,
          payload: res.data.event,
        });
      }

      dispatch({
        type: actionTypes.CREATE_EVENT_FROM_REQUEST_EVENT_SUCCESS,
        payload: res.data.requestEvent,
      });
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.CREATE_EVENT_FROM_REQUEST_EVENT_SUCCESS,
        payload: placeHolderIndex,
      });
      throw err;
    });
}
